import React from "react";
import "./FirstSection.css";

function FirstSection() {
  return (
    <div className="firstsection">
      <div className="hero-content">
        <div className="text-content" >
          <span>Reliable Delivery App</span>
          <p>
            Book Bike & Truck in 10 Seconds <br />
            Amazingly Low Fare
          </p>
        </div>
      </div>

      {/* Location & Tabs Section */}
      <div className="booking-box">
        <div className="tabs">
          <button className="active">Daily</button>
          {/* <button
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.DriveOme.com",
                "_blank"
              )
            }
          >
            Rental
          </button> */}
          <button
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.DriveOme.com",
                "_blank"
              )
            }
          >
            Outstation
          </button>
        </div>

        <div className="locations">
          <div
            className="location-input"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.DriveOme.com",
                "_blank"
              )
            }
          >
            <span className="dot green"></span> Current Location
          </div>
          <div
            className="location-input"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.DriveOme.com",
                "_blank"
              )
            }
          >
            <span className="dot red"></span> Enter Location
          </div>
          <button
            className="search-btn"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.DriveOme.com",
                "_blank"
              )
            }
          >
            SEARCH VEHICLE
          </button>
        </div>
      </div>
    </div>
  );
}

export default FirstSection;
